module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/promos/promo-edit/promo-edit.component.scss
// module id = ./src/app/promos/promo-edit/promo-edit.component.scss
// module chunks = main